import React from 'react';
import { SafeAreaView, Image } from "react-native";
import Lightbox from 'react-native-lightbox';

export default function LightboxView({ navigator, src }) {

  return (
    <Lightbox navigator={navigator}>
      <Image
        style={{ height: 300 }}
        source={src}
      />
    </Lightbox>
  )
};